"use client";

import { VimeoPhoneVideo } from "@/components/educators/components/VimeoPhoneVideo";
import { HOLLY_VIDEO_TRANSCRIPT } from "@/components/educators/data/video-transcripts";
import { SectionFrame } from "@/components/ui/section-frame";
import Link from "next/link";

export function HollySpotlightSection() {
  return (
    <SectionFrame
      startColor="rgb(var(--accent-pink))"
      endColor="rgb(var(--accent-pink-deep))"
      showTopBorder={false}
      clipOverflowX={false}
    >
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-start">
          <div>
            <VimeoPhoneVideo
              outerClassName="flex justify-center lg:-mt-24 bg-[url('/images/marketing/educators/featured/april/blob.svg')] bg-center bg-contain bg-no-repeat"
              phoneContainerClassName="-rotate-[2.5deg]"
              src="https://player.vimeo.com/video/1210458420?title=0&byline=0&portrait=0&controls=0&playsinline=1&api=1&player_id=holly-vimeo"
              title="Holly educator spotlight video"
              transcript={HOLLY_VIDEO_TRANSCRIPT}
              transcriptTestId="holly-transcript"
            />
          </div>

          <div className="flex flex-col gap-6">
            <div>
              <p className="text-white/90 font-extrabold text-lg md:text-xl">
                Holly, 5th Grade Teacher
              </p>
              <p className="mt-2 charlie-kingdom-font text-cta-yellow text-3xl md:text-4xl leading-tight">
                Ready for the school year
              </p>
            </div>

            <p className="text-white/90 font-semibold text-base md:text-lg leading-relaxed">
              Holly recommends PlayMath.org to get students ready for the year ahead. The games keep
              K–middle school learners engaged while building problem-solving and mathematical
              thinking, perfect for early finishers, substitute plans, and math centers.
            </p>

            <div className="pt-2">
              <Link
                href="/games"
                className="w-full max-w-[520px] inline-flex items-center justify-center bg-cta-yellow text-black rounded-full border-4 border-black shadow-cta-yellow px-8 py-5 charlie-kingdom-font text-xl md:text-2xl hover:bg-cta-yellow-hover transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-black/20"
              >
                <span className="relative -top-1">Explore free math games</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </SectionFrame>
  );
}
